import React from "react";
import Moment from "moment";

import Form from "./form";

import { connect } from "react-redux";
import {
    create,
    load,
    reset,
    isLoaded,
    isLoading,
    getError,
    getData,
    getSecondaryData,
    getFormSuccess,
} from "../../../../redux/actions/manager/cron/form";

import {
    CACHE_CAMPAIGN,
    CACHE_PRIORITY,
    CACHE_TAG,
    CACHE_VENDOR,
    CACHE_CLIENT,
    loadCache,
    isCacheLoading,
    isCacheLoaded,
    getCampaignsForSelect,
    getCampaignsById,
    getClientsForSelect,
    getClientsById,
    getVendorsForSelect,
    getVendorsById,
} from "../../../../redux/actions/cache/interface";

import { getTagsById, getTagsForSelect } from "../../../../redux/actions/cache/tag";

import { getPrioritiesById, getPrioritiesForSelect } from "../../../../redux/actions/cache/priority";

import { isNotValid, translateSymfonyErrorToFormik } from "../../../../core/utils/form";

import Loader from "../../../../components/loader";

import { CRON_REPORT_SUBTYPE_JOB } from "../../const";

/**
 * Container:
 *
 *   Se encarga de la conexion entre Redux y el Componente  que presenta los datos
 *
 * De paso en algunos caso, excepto formularios se maneja el Loading y el título.
 *
 * OBS: En formularios es mejor que el 'loading' lo maneje el formulario dado que Formik
 *    si se redibuja pierde los datos, entonces hay que tener cuidado con eso.
 */
class Container extends React.Component {
    constructor(props) {
        super(props);
        this.state = { id: props.match.params.id };
    }

    componentDidMount() {
        this.props.loadCache();
        this.props.load();
    }

    _goBack = () => {
        this.props.reset();
        this.props.history.goBack();
    };

    componentWillUnmount() {
        this.props.reset();
    }

    /**
     * Función que maneja el submit del formulario
     *
     * Recordar que se puede tratar de un alta o una edición
     */
    _handleSubmit = (values, bag) => {
        /* convertir fecha al timezone del back */
        const from = values.from == null ? null : Moment(values.from).format("DD/MM/YYYY");
        const to = values.to == null ? null : Moment(values.to).format("DD/MM/YYYY");

        let parameters = {
            ...values,
            from,
            to,
        };

        //if (values.subtype !== CRON_REPORT_SUBTYPE_JOB) {
        //    delete parameters.from;
        //    delete parameters.to;
        //}

        if (values.client) {
            parameters = {
                ...parameters,
                clientName: this.props.clientsById[values.client].name,
            };
        }

        if (values.vendor) {
            parameters = {
                ...parameters,
                vendorName: this.props.vendorsById[values.vendor].name,
            };
        }

        if (values.campaign) {
            parameters = {
                ...parameters,
                campaignName: this.props.campaignsById[values.campaign].name,
            };
        }

        if (values.tag) {
            parameters = {
                ...parameters,
                tagName: this.props.tagsById[values.tag]?.name,
            };
        }

        if (values.priority) {
            parameters = {
                ...parameters,
                priorityName: this.props.prioritiesById[values.priority]?.name,
            };
        }

        delete parameters.type;
        delete parameters.subtype;
        Object.keys(parameters).forEach((e) => {
            if (parameters[e] === "") {
                delete parameters[e];
            }
        });

        const parametersString = JSON.stringify(parameters);

        let form = {
            type: "REPORT",
            subtype: values.subtype,
            parameters: parameters,
            parametersString: parametersString,
        };

        const ret = this.props.create(JSON.stringify(form));

        ret.then((response) => {
            if (isNotValid(response)) {
                bag.setErrors(translateSymfonyErrorToFormik(response.errors.children));
            } else {
                if (this.props.success) {
                    this._goBack();
                    return;
                }
            }
            bag.setSubmitting(false);
        }).catch((e) => {
            alert("Se ha producido un error desconocido");
        });
    };

    render() {
        const { data, loading, loaded, alta } = this.props;
        return (
            <>
                <Loader loading={loading} />
                {!loading && loaded && data && <Form {...this.props} handleSubmit={this._handleSubmit} />}
            </>
        );
    }
}

const cacheList = [CACHE_CAMPAIGN, CACHE_VENDOR, CACHE_CLIENT, CACHE_PRIORITY, CACHE_TAG];

function MapStateToProps(state) {
    return {
        error: getError(state),
        data: getData(state),
        loading: isLoading(state) || isCacheLoading(state, cacheList),
        loaded: isLoaded(state) && isCacheLoaded(state, cacheList),
        success: getFormSuccess(state),
        clients: getClientsForSelect(state),
        clientsById: getClientsById(state),
        vendors: getVendorsForSelect(state),
        vendorsById: getVendorsById(state),
        campaigns: getCampaignsForSelect(state),
        campaignsById: getCampaignsById(state),
        tags: getTagsForSelect(state),
        tagsById: getTagsById(state),
        priorities: getPrioritiesForSelect(state),
        prioritiesById: getPrioritiesById(state),
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        loadCache: () => loadCache(cacheList)(dispatch),

        load: () => dispatch(load()),
        create: (form) => dispatch(create(form)),
        reset: () => dispatch(reset()),
    };
};

export default connect(MapStateToProps, mapDispatchToProps)(Container);
